import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../../shared/components/auth/withAuth';
import { handleOAuthCallback } from '../../../utils/auth/oauth';

const EntraCallback = () => {
  const auth = useAuth();
  const history = useHistory();

  useEffect(() => {
    const process = async () => {
      const result = await handleOAuthCallback(auth?.signin);

      if (result.success) {
        history.replace('/dashboard');
      } else if (result.error) {
        history.replace('/login?sso_error=1');
      } else {
        history.replace('/login');
      }
    };

    process();
  }, []);

  return (
    <div className="account account--not-photo">
      <div className="account__wrapper">
        <div className="account__card">
          <span className="account__head" />
          <div className="account__btns">
            <div className="text-center">Processing login...</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EntraCallback;
